import React from 'react';

import '../Tutorial.css';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";
import Hole from "../Hole";

function T75SpellTarget() {

    /*
  useEffect(() => {
    UserService.sendEvent('SpellTarget75');
  }, []);
     */

  const text = 'Fire Bolt\' is a spell that requires a target. You can choose either an enemy unit or the enemy themselves.';


    return (
        <div>

            <div className='SpellTarget75Bottom'></div>

            <div className='SpellTarget75Right'></div>

             <Hole className={'.hp_cpu'} diameter={250} />

            <TutorialGirl position={'Right'}/>
            <div className='tutorialContainer tutorialBottomContainer75'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>

        </div>

    );
}

export default T75SpellTarget;
